import Page, { getProps } from 'src/modules/public-service/jdih'

export const getServerSideProps = getProps

export default Page
